import { generatePath } from 'react-router-dom';

import { ROUTES } from '#client/manifest';

import { processMenu } from '../utils/menu';

/**
 * Get the documents menu items.
 *
 * @param {{
 *  businessEntityUuid: string
 * }} params
 * @returns {Array}
 */
export function getDocumentsMenuItems({ businessEntityUuid }) {
  return [
    {
      order: 10,
      title: 'Business Records',
      path: generatePath(ROUTES.businessRecords, { businessEntityUuid })
    },
    {
      order: 20,
      title: 'Document Templates',
      path: generatePath(ROUTES.documentTemplates, { businessEntityUuid })
    }
  ];
}

/**
 * Get the documents menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getDocumentsMenu({ businessEntityUuid, order }) {
  return processMenu({
    title: 'Documents',
    icon: 'folder-fill.svg',
    links: getDocumentsMenuItems({ businessEntityUuid }),
    order
  });
}
